export interface PhoneCode {
  label: string;
  code: string;
  availableLength: number;
}

export const codes: PhoneCode[] = [
  {
    label: 'RU',
    code: '+7',
    availableLength: 11,
  },
  {
    label: 'UA',
    code: '+380',
    availableLength: 12,
  },
  {
    label: 'KZ',
    code: '+77',
    availableLength: 11,
  },
  {
    label: 'BY',
    code: '+375',
    availableLength: 12,
  },
  {
    label: 'KG',
    code: '+996',
    availableLength: 12,
  },
  {
    label: 'GE',
    code: '+995',
    availableLength: 11,
  }
];

export const createPhoneCodeRegex = (): RegExp => {
  // Экранируем "+" и собираем все коды в группу через "|"
  const pattern = codes
    .map(({ code }) => `\\+?${code.replace('+', '')}`) // "+996" → "\+?996"
    .join('|');

  return new RegExp(`^(${pattern})`);
}
